(function () {
  var GUARD_TIMEOUT_MS = 10000;
  var configElement = document.getElementById('MembershipCartGuardConfig');
  if (!configElement) return;

  var config = {};
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    config = {};
  }

  var configuredVariantIds = new Set(
    (Array.isArray(config.variantIds) ? config.variantIds : []).map(function (variantId) {
      return String(variantId);
    })
  );
  var statusElement = document.getElementById('MembershipCartGuardStatus');
  var inFlight = null;
  var rerunRequested = false;
  var checkoutLocked = false;
  var observerTimer = null;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path.replace(/^\/+/, '');
  }

  function fetchWithTimeout(url, options) {
    var controller = new AbortController();
    var timeoutId = window.setTimeout(function () {
      controller.abort();
    }, GUARD_TIMEOUT_MS);
    var requestOptions = Object.assign({}, options || {}, { signal: controller.signal });

    return fetch(url, requestOptions).finally(function () {
      window.clearTimeout(timeoutId);
    });
  }

  function setStatus(message, isError) {
    if (!statusElement) return;
    statusElement.textContent = message || '';
    statusElement.hidden = !message;
    statusElement.classList.toggle('membership-message--error', Boolean(isError));
    statusElement.setAttribute('role', isError ? 'alert' : 'status');
  }

  function checkoutControls() {
    return document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]'
    );
  }

  function lockCheckout(message) {
    checkoutLocked = true;
    checkoutControls().forEach(function (control) {
      if (control.dataset.membershipGuardDisabled === 'true') return;
      control.dataset.membershipGuardDisabled = 'true';
      control.dataset.membershipGuardPreviouslyDisabled = control.disabled ? 'true' : 'false';
      control.setAttribute('aria-disabled', 'true');
      if ('disabled' in control) control.disabled = true;
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach(function (container) {
      container.dataset.membershipGuardDynamicCheckout = 'true';
    });

    if (message) setStatus(message, false);
  }

  function unlockCheckout() {
    checkoutLocked = false;
    document.querySelectorAll('[data-membership-guard-disabled="true"]').forEach(function (control) {
      if (control.dataset.membershipGuardPreviouslyDisabled !== 'true' && 'disabled' in control) {
        control.disabled = false;
      }
      control.removeAttribute('aria-disabled');
      delete control.dataset.membershipGuardDisabled;
      delete control.dataset.membershipGuardPreviouslyDisabled;
    });

    document.querySelectorAll('[data-membership-guard-dynamic-checkout="true"]').forEach(function (container) {
      delete container.dataset.membershipGuardDynamicCheckout;
    });
    setStatus('', false);
  }

  function readBlockedKeys(root) {
    var keys = new Set();
    (root || document).querySelectorAll('[data-membership-cart-blocker]').forEach(function (element) {
      try {
        var parsed = JSON.parse(element.textContent || '[]');
        if (Array.isArray(parsed)) {
          parsed.forEach(function (key) {
            if (key) keys.add(String(key));
          });
        }
      } catch (error) {
        return;
      }
    });
    return keys;
  }

  function fetchCartJsonKeys() {
    return fetchWithTimeout(route('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not verify the cart.');
      return response.json();
    }).then(function (cart) {
      var keys = new Set();
      (cart.items || []).forEach(function (item) {
        if (configuredVariantIds.has(String(item.variant_id || item.id))) {
          keys.add(String(item.key));
        }
      });
      return keys;
    });
  }

  function fetchRenderedCartKeys() {
    var cartUrl = new URL(window.routes && window.routes.cart_url ? window.routes.cart_url : route('cart'), window.location.origin);
    cartUrl.searchParams.set('section_id', 'main-cart-items');

    return fetchWithTimeout(cartUrl.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not validate membership items in the cart.');
      return response.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      return readBlockedKeys(parsed);
    });
  }

  function verifyBlockedKeys() {
    if (configuredVariantIds.size) {
      return fetchCartJsonKeys().then(function (keys) {
        readBlockedKeys(document).forEach(function (key) {
          keys.add(key);
        });
        return keys;
      });
    }

    return fetchRenderedCartKeys();
  }

  function removeBlockedKeys(keys) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    return fetchWithTimeout(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not remove the membership product from the cart.');
      return response.json();
    }).then(function (cart) {
      var remainingKeys = new Set(
        (cart.items || []).map(function (item) {
          return String(item.key);
        })
      );
      var blockedKeyRemains = Array.from(keys).some(function (key) {
        return remainingKeys.has(String(key));
      });
      if (blockedKeyRemains) throw new Error('A membership cart item could not be removed.');
      window.location.reload();
    });
  }

  function checkCart(options) {
    var opts = options || {};
    if (inFlight) {
      rerunRequested = true;
      return inFlight;
    }

    if (opts.lockImmediately) {
      lockCheckout(config.checkingMessage || 'Checking your cart…');
    }

    inFlight = verifyBlockedKeys()
      .then(function (keys) {
        if (keys.size) {
          lockCheckout(config.blockedMessage || 'Removing the membership product from the regular cart…');
          return removeBlockedKeys(keys);
        }
        unlockCheckout();
        return true;
      })
      .catch(function (error) {
        lockCheckout();
        setStatus(config.errorMessage || 'We could not verify the cart. Please refresh and try again.', true);
        if (config.debug) console.error('[membership] cart guard failed', error);
        return false;
      })
      .finally(function () {
        inFlight = null;
        if (rerunRequested) {
          rerunRequested = false;
          return checkCart({ lockImmediately: true });
        }
      });

    return inFlight;
  }

  function checkLocalMarkers() {
    var keys = readBlockedKeys(document);
    if (!keys.size) return;
    lockCheckout(config.blockedMessage || 'Removing the membership product from the regular cart…');
    checkCart({ lockImmediately: true });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      var form = submitter.form || event.target;
      if (form.dataset.membershipGuardBypass === 'true') {
        delete form.dataset.membershipGuardBypass;
        return;
      }

      event.preventDefault();
      lockCheckout(config.checkingMessage || 'Checking your cart…');
      checkCart({ lockImmediately: true }).then(function (isClean) {
        if (!isClean || checkoutLocked) return;
        form.dataset.membershipGuardBypass = 'true';
        form.requestSubmit(submitter);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
      if (!link) return;
      event.preventDefault();
      lockCheckout(config.checkingMessage || 'Checking your cart…');
      checkCart({ lockImmediately: true }).then(function (isClean) {
        if (isClean && !checkoutLocked) window.location.assign(link.href);
      });
    },
    true
  );

  function initialize() {
    checkLocalMarkers();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        lockCheckout(config.checkingMessage || 'Checking your cart…');
        checkCart({ lockImmediately: true });
      });
    }

    var observer = new MutationObserver(function (mutations) {
      var blockerWasAdded = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches('[data-membership-cart-blocker]') || node.querySelector('[data-membership-cart-blocker]'))
          );
        });
      });
      if (!blockerWasAdded) return;

      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(checkLocalMarkers, 25);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
